import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiChevronLeft, FiChevronRight, FiQuote } = FiIcons;

const CustomerTestimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      location: "Beverly Hills, CA",
      rating: 5,
      text: "Outstanding service from start to finish! The AI assistant helped me find the perfect Q5, and the financing was seamless. Couldn't be happier with my purchase.",
      vehicle: "2024 Audi Q5 Premium Plus",
      image: "https://images.unsplash.com/photo-1494790108755-2616b332c371?w=80&h=80&fit=crop&crop=face"
    },
    {
      id: 2,
      name: "Michael Chen",
      location: "Los Angeles, CA",
      rating: 5,
      text: "The team went above and beyond to make sure I got the best deal. The trade-in process was transparent and fair. Highly recommend this dealership!",
      vehicle: "2024 Audi A4 S-Line",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face"
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      location: "Santa Monica, CA",
      rating: 5,
      text: "Professional, knowledgeable, and no pressure sales approach. They helped me understand all my options and made the entire process stress-free.",
      vehicle: "2024 Audi Q7 Prestige",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face"
    },
    {
      id: 4,
      name: "David Park",
      location: "Pasadena, CA",
      rating: 5,
      text: "Exceptional customer service! The AI recommendations were spot-on, and the financing team found me a great rate. Will definitely return for my next Audi.",
      vehicle: "2023 Audi Q8 Premium Plus",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face"
    }
  ];

  // Auto-rotate testimonials
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gray-800 rounded-lg p-6 border border-gray-700"
    >
      <h3 className="text-xl font-bold text-white mb-6 flex items-center">
        <SafeIcon icon={FiQuote} className="w-5 h-5 mr-2 text-audi-red" />
        What Our Customers Say
      </h3>

      <div className="relative">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
            className="space-y-4"
          >
            {/* Stars */}
            <div className="flex space-x-1">
              {[...Array(currentTestimonial.rating)].map((_, i) => (
                <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-yellow-400 fill-current" />
              ))}
            </div>

            {/* Testimonial Text */}
            <blockquote className="text-gray-200 text-lg leading-relaxed italic">
              "{currentTestimonial.text}"
            </blockquote>

            {/* Customer Info */}
            <div className="flex items-center space-x-4">
              <img
                src={currentTestimonial.image}
                alt={currentTestimonial.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <div className="font-semibold text-white">{currentTestimonial.name}</div>
                <div className="text-gray-400 text-sm">{currentTestimonial.location}</div>
                <div className="text-audi-red text-sm font-medium">{currentTestimonial.vehicle}</div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Navigation */}
        <div className="flex items-center justify-between mt-6">
          <button
            onClick={prevTestimonial}
            className="p-2 text-gray-400 hover:text-white transition-colors"
          >
            <SafeIcon icon={FiChevronLeft} className="w-5 h-5" />
          </button>

          {/* Dots Indicator */}
          <div className="flex space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  index === currentIndex ? 'bg-audi-red' : 'bg-gray-600'
                }`}
              />
            ))}
          </div>

          <button
            onClick={nextTestimonial}
            className="p-2 text-gray-400 hover:text-white transition-colors"
          >
            <SafeIcon icon={FiChevronRight} className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* View All Reviews Link */}
      <div className="mt-4 text-center">
        <button className="text-audi-red hover:text-red-400 text-sm font-medium transition-colors">
          View All 2,847 Reviews →
        </button>
      </div>
    </motion.div>
  );
};

export default CustomerTestimonials;